(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["frequently-bought-together"] && !Shopify.designMode) return;
  try {
    (function () {
    var desktopQuery = window.matchMedia('(min-width: 750px)');

    function getSection(block) {
      var sectionId = block.getAttribute('data-vm-fbt-section-id');
      return document.getElementById('ProductSection-' + sectionId) || block.closest('.product-information');
    }

    /*function placeBlock(block) {
      var section = getSection(block);
      if (!section) return;

      if (desktopQuery.matches) {
        var media = section.querySelector('.product-information__media');
        if (media) {
          media.classList.add('vm-fbt-media-stack');

          if (block.parentElement !== media) {
            media.appendChild(block);
          }
        }
        return;
      }

      section.querySelectorAll('.product-information__media.vm-fbt-media-stack').forEach(function (media) {
        media.classList.remove('vm-fbt-media-stack');
      });

      var qtyAtc = section.querySelector('.vm-qty-atc');
      if (qtyAtc && qtyAtc.parentElement && qtyAtc.nextElementSibling !== block) {
        qtyAtc.insertAdjacentElement('afterend', block);
        return;
      }

      var details = section.querySelector('.product-details .group-block') || section.querySelector('.product-details');
      if (details && block.parentElement !== details) {
        details.appendChild(block);
      }
    }*/

    function placeBlock(block) {
  var section = getSection(block);
  if (!section) return;

  if (desktopQuery.matches) {
    var media = section.querySelector('.product-information__media');
    if (media) {
      media.classList.add('vm-fbt-media-stack');

      if (block.parentElement !== media) {
        media.appendChild(block);
      }
    }
    return;
  }

  section.querySelectorAll('.product-information__media.vm-fbt-media-stack').forEach(function (media) {
    media.classList.remove('vm-fbt-media-stack');
  });

  var qtyAtc = section.querySelector('.vm-qty-atc');
  var videoSlider = section.querySelector('[data-cham-pvs-block][data-mobile-after-qty-atc="true"]');

  if (videoSlider && videoSlider.parentElement && videoSlider.nextElementSibling !== block) {
    videoSlider.insertAdjacentElement('afterend', block);
    return;
  }

  if (qtyAtc && qtyAtc.parentElement && qtyAtc.nextElementSibling !== block) {
    qtyAtc.insertAdjacentElement('afterend', block);
    return;
  }

  var details = section.querySelector('.product-details .group-block') || section.querySelector('.product-details');
  if (details && block.parentElement !== details) {
    details.appendChild(block);
  }
}

    function setCartCountEverywhere(count) {
      var countString = String(count);
      var selectors = [
        '#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]',
        '.cart-count-bubble span[aria-hidden="true"]',
        '[data-cart-count]',
        '[data-cart-bubble-count]',
        '[data-header-cart-count]',
        'cart-icon [ref="cartBubbleCount"]',
        '.header__cart-count',
        '.cart-count',
        '#CartCount',
        '#cart-count'
      ];

      selectors.forEach(function (selector) {
        document.querySelectorAll(selector).forEach(function (element) {
          element.textContent = countString;
        });
      });

      updateHorizonCartIcons(count);
    }

    function updateHorizonCartIcons(count) {
      var countString = String(count);

      document.querySelectorAll('cart-icon').forEach(function (cartIcon) {
        if (typeof cartIcon.renderCartBubble === 'function') {
          cartIcon.renderCartBubble(count, false);
          return;
        }

        var bubble = cartIcon.querySelector('[ref="cartBubble"]');
        var bubbleCount = cartIcon.querySelector('[ref="cartBubbleCount"]');

        if (bubbleCount) {
          bubbleCount.textContent = count < 100 ? countString : '';
          bubbleCount.classList.toggle('hidden', count === 0);
        }

        if (bubble) bubble.classList.toggle('visually-hidden', count === 0);
        cartIcon.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
      });

      try {
        sessionStorage.setItem(
          'cart-count',
          JSON.stringify({
            value: countString,
            timestamp: Date.now()
          })
        );
      } catch (error) {}
    }

    function getVmCartSectionIds() {
      var ids = new Set();

      document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
        if (el.dataset.sectionId) ids.add(el.dataset.sectionId);
      });

      return Array.from(ids);
    }

    function refreshVmCartSections(sections) {
      if (!sections) return;

      var detail = {
        data: {
          sections: sections
        }
      };

      document.dispatchEvent(new CustomEvent('cart:update', { detail: detail }));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: detail }));
      document.dispatchEvent(new CustomEvent('cart:change', { detail: detail }));
    }

    function dispatchCartEvents(cart, sections) {
      if (sections) {
        refreshVmCartSections(sections);
      }

      var detail = {
        cart: cart,
        count: cart.item_count,
        data: {
          sections: sections || {}
        }
      };

      document.dispatchEvent(new CustomEvent('cart:updated', { detail: detail }));
      document.dispatchEvent(new CustomEvent('cart:change', { detail: detail }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: detail }));
      window.dispatchEvent(new CustomEvent('cart:updated', { detail: detail }));
    }

    function addButtonHandlers(block) {
      block.querySelectorAll('[data-vm-fbt-atc]').forEach(function (button) {
        if (button.getAttribute('data-vm-fbt-bound') === 'true') return;
        button.setAttribute('data-vm-fbt-bound', 'true');

        button.addEventListener('click', function () {
          if (button.disabled) return;

          var variantId = parseInt(button.getAttribute('data-vm-fbt-variant-id'), 10);
          if (!variantId) return;

          var normalLabel = button.getAttribute('data-vm-fbt-label') || button.textContent;
          var loadingLabel = button.getAttribute('data-vm-fbt-loading-label') || normalLabel;
          var addedLabel = button.getAttribute('data-vm-fbt-added-label') || normalLabel;

          button.classList.add('is-loading');
          button.textContent = loadingLabel;

          var sectionIds = getVmCartSectionIds();

          var addBody = {
            items: [{ id: variantId, quantity: 1 }]
          };

          if (sectionIds.length) {
            addBody.sections = sectionIds.join(',');
            addBody.sections_url = window.location.pathname;
          }

          var addedSections = null;

          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            credentials: 'same-origin',
            body: JSON.stringify(addBody)
          })
  .then(function (response) {
    if (!response.ok) throw new Error('Unable to add this product.');
    return response.json();
  })
  .then(function (addResponse) {
    addedSections = addResponse.sections || null;

    return fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store'
    });
  })
            .then(function (response) {
              if (!response.ok) throw new Error('Unable to refresh cart.');
              return response.json();
            })
            .then(function (cart) {
              setCartCountEverywhere(cart.item_count);
              dispatchCartEvents(cart, addedSections);
              button.textContent = addedLabel;

              window.setTimeout(function () {
                button.textContent = normalLabel;
              }, 1400);
            })
            .catch(function () {
              button.textContent = normalLabel;
            })
            .finally(function () {
              button.classList.remove('is-loading');
            });
        });
      });
    }

    function initFrequentlyBoughtTogether() {
      document.querySelectorAll('[data-vm-fbt-block]').forEach(function (block) {
        placeBlock(block);
        addButtonHandlers(block);
      });
    }

    initFrequentlyBoughtTogether();
    document.addEventListener('DOMContentLoaded', initFrequentlyBoughtTogether);
    document.addEventListener('shopify:section:load', initFrequentlyBoughtTogether);
    document.addEventListener('shopify:block:select', initFrequentlyBoughtTogether);

    if (desktopQuery.addEventListener) {
      desktopQuery.addEventListener('change', initFrequentlyBoughtTogether);
    } else if (desktopQuery.addListener) {
      desktopQuery.addListener(initFrequentlyBoughtTogether);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["quantity-atc-buynow"] && !Shopify.designMode) return;
  try {
    (function () {
    function toInt(v, fallback) {
      const n = parseInt(v, 10);
      return Number.isFinite(n) ? n : fallback;
    }

    function stopAll(e) {
      if (!e) return;
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    }

    function headerRoot() {
      return document.querySelector('header') ||
             document.querySelector('.shopify-section--header') ||
             document.querySelector('#shopify-section-header') ||
             document;
    }

    function updateHorizonCartIcons(count) {
      const countStr = String(count);

      document.querySelectorAll('cart-icon').forEach((cartIcon) => {
        if (typeof cartIcon.renderCartBubble === 'function') {
          cartIcon.renderCartBubble(count, false);
          return;
        }

        const bubble = cartIcon.querySelector('[ref="cartBubble"]');
        const bubbleCount = cartIcon.querySelector('[ref="cartBubbleCount"]');

        if (bubbleCount) {
          bubbleCount.textContent = count < 100 ? countStr : '';
          bubbleCount.classList.toggle('hidden', count === 0);
        }

        if (bubble) bubble.classList.toggle('visually-hidden', count === 0);
        cartIcon.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
      });

      try {
        sessionStorage.setItem('cart-count', JSON.stringify({ value: countStr, timestamp: Date.now() }));
      } catch (e) {}
    }

    function setCartCountEverywhere(count) {
      const countStr = String(count);

      ['#cart-icon-bubble', '.cart-icon-bubble', '[data-cart-icon-bubble]'].forEach((sel) => {
        document.querySelectorAll(sel).forEach((wrap) => {
          const bubble = wrap.querySelector('.cart-count-bubble') || wrap.querySelector('[data-cart-count-bubble]');

          if (bubble) {
            const ariaHidden = bubble.querySelector('span[aria-hidden="true"]');
            if (ariaHidden) ariaHidden.textContent = countStr;

            const visHidden = bubble.querySelector('.visually-hidden');
            if (visHidden) visHidden.textContent = `${count} item${count === 1 ? '' : 's'}`;

            if (count > 0) bubble.removeAttribute('hidden');
            else bubble.setAttribute('hidden', 'hidden');
          }
        });
      });

      [
        '[data-cart-count]',
        '[data-cart-bubble-count]',
        '[data-header-cart-count]',
        '[data-cart-item-count]',
        'cart-icon [ref="cartBubbleCount"]',
        '.header__cart-count',
        '.cart-count',
        '.site-header__cart-count',
        '#CartCount',
        '#cart-count'
      ].forEach((sel) => {
        document.querySelectorAll(sel).forEach((el) => {
          el.textContent = countStr;
          if (el.hasAttribute('data-count')) el.setAttribute('data-count', countStr);
          if (el.hasAttribute('data-cart-count')) el.setAttribute('data-cart-count', countStr);
        });
      });

      const h = headerRoot();
      h.querySelectorAll('span, sup, div').forEach((el) => {
        const t = (el.textContent || '').trim();
        if (!/^\d+$/.test(t)) return;

        const cls = (el.className || '').toString().toLowerCase();
        if (!/(cart|count|bubble|badge)/.test(cls)) return;

        el.textContent = countStr;
      });

      updateHorizonCartIcons(count);

      const cart = { item_count: count };
      const detail = { cart, count };
      document.dispatchEvent(new CustomEvent('cart:updated', { detail }));
      document.dispatchEvent(new CustomEvent('cart:change', { detail }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail }));
      window.dispatchEvent(new CustomEvent('cart:updated', { detail }));
    }

    function getVisibleCartCount() {
      const probes = [
        '#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]',
        '.cart-count-bubble span[aria-hidden="true"]',
        '[data-cart-count]',
        '[data-cart-bubble-count]',
        '[data-header-cart-count]',
        'cart-icon [ref="cartBubbleCount"]',
        '.header__cart-count',
        '.cart-count',
        '#CartCount',
        '#cart-count'
      ];

      for (const sel of probes) {
        const el = document.querySelector(sel);
        if (!el) continue;

        const t = (el.textContent || '').trim();
        if (/^\d+$/.test(t)) return parseInt(t, 10);
      }

      return null;
    }

    async function fetchCartJSON() {
      const res = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        cache: 'no-store',
        credentials: 'same-origin'
      });

      if (!res.ok) throw new Error('Unable to fetch cart.');
      return res.json();
    }


    let vmCartDrawerLoadingCount = 0;
    let vmCartDrawerLoadingTimer = null;

    function getVmCartDrawerElement() {
      return (
        document.querySelector('cart-drawer-component') ||
        document.querySelector('cart-drawer') ||
        document.querySelector('#CartDrawer') ||
        document.querySelector('.cart-drawer') ||
        document.querySelector('[data-cart-drawer]')
      );
    }

    function ensureVmCartDrawerLoader() {
      const drawer = getVmCartDrawerElement();
      if (!drawer) return null;

      let host = drawer;
      const innerDialog = drawer.querySelector?.('dialog') || drawer.querySelector?.('[role="dialog"]');
      if (innerDialog instanceof HTMLElement) host = innerDialog;

      const hostStyle = window.getComputedStyle(host);
      if (hostStyle.position === 'static') {
        host.style.position = 'relative';
      }

      let loader = host.querySelector(':scope > .vm-cart-drawer-loading');
      if (!loader) {
        loader = document.createElement('div');
        loader.className = 'vm-cart-drawer-loading';
        loader.setAttribute('aria-hidden', 'true');
        loader.innerHTML = '<span class="vm-cart-drawer-loading__spinner" aria-label="Loading cart"></span>';
        host.appendChild(loader);
      }

      return loader;
    }

    function showVmCartDrawerLoader() {
      if (vmCartDrawerLoadingTimer) {
        window.clearTimeout(vmCartDrawerLoadingTimer);
        vmCartDrawerLoadingTimer = null;
      }

      vmCartDrawerLoadingCount += 1;
      const loader = ensureVmCartDrawerLoader();
      if (loader) loader.classList.add('is-active');
    }

    function hideVmCartDrawerLoader(force) {
      if (force) {
        vmCartDrawerLoadingCount = 0;
      } else {
        vmCartDrawerLoadingCount = Math.max(0, vmCartDrawerLoadingCount - 1);
      }

      if (vmCartDrawerLoadingCount > 0) return;

      if (vmCartDrawerLoadingTimer) window.clearTimeout(vmCartDrawerLoadingTimer);
      vmCartDrawerLoadingTimer = window.setTimeout(() => {
        requestAnimationFrame(() => {
          const loader = ensureVmCartDrawerLoader();
          if (loader) loader.classList.remove('is-active');
        });
      }, 80);
    }

    function isVmCartRequest(input) {
      const raw = typeof input === 'string' ? input : input?.url || '';
      if (!raw) return false;

      let url;
      try {
        url = new URL(raw, window.location.origin);
      } catch (e) {
        return false;
      }

      const path = url.pathname;
      return (
        path.endsWith('/cart/add.js') ||
        path.endsWith('/cart/change.js') ||
        path.endsWith('/cart/update.js') ||
        path.endsWith('/cart/clear.js') ||
        path.includes('/cart/add') ||
        path.includes('/cart/change') ||
        path.includes('/cart/update') ||
        path.includes('/cart/clear')
      );
    }

    function installVmCartDrawerLoaderWatchers() {
      if (window.__vmCartDrawerLoaderInstalled) return;
      window.__vmCartDrawerLoaderInstalled = true;

      const originalFetch = window.fetch;
      if (typeof originalFetch === 'function') {
        window.fetch = function patchedVmCartFetch(input, init) {
          const shouldShowLoader = isVmCartRequest(input);
          if (shouldShowLoader) showVmCartDrawerLoader();

          return originalFetch.apply(this, arguments)
            .finally(() => {
              if (shouldShowLoader) hideVmCartDrawerLoader(false);
            });
        };
      }

      const originalOpen = XMLHttpRequest.prototype.open;
      const originalSend = XMLHttpRequest.prototype.send;

      XMLHttpRequest.prototype.open = function patchedVmCartXhrOpen(method, url) {
        this.__vmCartDrawerLoaderRequest = isVmCartRequest(url);
        return originalOpen.apply(this, arguments);
      };

      XMLHttpRequest.prototype.send = function patchedVmCartXhrSend() {
        if (this.__vmCartDrawerLoaderRequest) {
          showVmCartDrawerLoader();
          this.addEventListener('loadend', () => hideVmCartDrawerLoader(false), { once: true });
        }

        return originalSend.apply(this, arguments);
      };

      document.addEventListener('click', (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;

        const drawer = getVmCartDrawerElement();
        if (!drawer || !drawer.contains(target)) return;

        const actionEl = target.closest('button, a, input[type="submit"], input[type="button"], cart-remove-button, [data-cart-remove], [data-cart-update], [name="updates[]"], [name="minus"], [name="plus"]');
        if (!actionEl) return;

        const isClose = actionEl.matches('[aria-label*="Close"], [aria-label*="close"], [data-close], [data-dialog-close]');
        if (isClose) return;

        showVmCartDrawerLoader();
        window.setTimeout(() => hideVmCartDrawerLoader(false), 1600);
      }, true);

      document.addEventListener('change', (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;

        const drawer = getVmCartDrawerElement();
        if (!drawer || !drawer.contains(target)) return;

        if (target.matches('input[name="updates[]"], quantity-input input, .quantity__input, [data-quantity-input]')) {
          showVmCartDrawerLoader();
          window.setTimeout(() => hideVmCartDrawerLoader(false), 1600);
        }
      }, true);

      ['cart:update', 'cart:updated', 'cart:change', 'cart:refresh', 'cart:add', 'cart:added'].forEach((eventName) => {
        document.addEventListener(eventName, () => hideVmCartDrawerLoader(true));
      });
    }

    function getVmCartSectionIds() {
      const ids = new Set();

      document.querySelectorAll('cart-items-component[data-section-id]').forEach((el) => {
        if (el.dataset.sectionId) ids.add(el.dataset.sectionId);
      });

      return Array.from(ids);
    }

    function refreshVmCartSections(sections) {
      if (!sections) return;

      document.querySelectorAll('cart-items-component[data-section-id]').forEach((currentEl) => {
        const sectionId = currentEl.dataset.sectionId;
        const html = sections[sectionId];

        if (!sectionId || !html) return;

        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const freshEl =
          parsed.querySelector(`cart-items-component[data-section-id="${sectionId}"]`) ||
          parsed.querySelector('cart-items-component');

        if (freshEl) currentEl.replaceWith(freshEl);
      });

      const detail = { data: { sections: sections } };
      document.dispatchEvent(new CustomEvent('cart:update', { detail }));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail }));
      document.dispatchEvent(new CustomEvent('cart:change', { detail }));
      hideVmCartDrawerLoader(true);
    }

    async function addToCart(variantId, quantity) {
      const sectionIds = getVmCartSectionIds();
      const body = { items: [{ id: variantId, quantity }] };

      if (sectionIds.length) {
        body.sections = sectionIds.join(',');
        body.sections_url = window.location.pathname;
      }

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        cache: 'no-store',
        credentials: 'same-origin',
        body: JSON.stringify(body)
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data?.description || data?.message || 'Unable to add to cart.');

      refreshVmCartSections(data.sections);
      return data;
    }


    function dispatchVmCartAddEvents(cart, addData) {
      const detail = {
        cart: cart || null,
        data: addData || null,
        source: 'vm-qty-atc',
        sections: addData?.sections || null
      };

      document.dispatchEvent(new CustomEvent('cart:add', { detail }));
      document.dispatchEvent(new CustomEvent('cart:added', { detail }));
      document.dispatchEvent(new CustomEvent('cart:add:success', { detail }));
      window.dispatchEvent(new CustomEvent('cart:add', { detail }));
    }

    function openVmCartDrawer() {
      const drawers = [
        'cart-drawer-component',
        'cart-drawer',
        '#CartDrawer',
        '.cart-drawer'
      ];

      for (const sel of drawers) {
        const drawer = document.querySelector(sel);
        if (!drawer) continue;

        try {
          drawer.setAttribute('auto-open', '');
        } catch (e) {}

        if (typeof drawer.open === 'function') {
          drawer.open();
          return true;
        }

        if (typeof drawer.showDialog === 'function') {
          drawer.showDialog();
          return true;
        }

        if (typeof drawer.showModal === 'function') {
          drawer.showModal();
          return true;
        }

        const dialog =
          drawer.querySelector?.('dialog') ||
          drawer.querySelector?.('[role="dialog"]');

        if (dialog) {
          if (typeof dialog.showModal === 'function' && !dialog.open) {
            dialog.showModal();
          } else if (typeof dialog.show === 'function' && !dialog.open) {
            dialog.show();
          }

          drawer.classList.add('is-open', 'active', 'animate');
          document.documentElement.classList.add('overflow-hidden');
          document.body.classList.add('overflow-hidden');
          return true;
        }

        drawer.classList.add('is-open', 'active', 'animate');
        drawer.removeAttribute('hidden');
        document.documentElement.classList.add('overflow-hidden');
        document.body.classList.add('overflow-hidden');
        return true;
      }

      const cartButton =
        document.querySelector('[aria-controls="CartDrawer"]') ||
        document.querySelector('[data-cart-drawer-toggle]') ||
        document.querySelector('button[name="cart"]');

      if (cartButton instanceof HTMLElement) {
        cartButton.click();
        return true;
      }

      return false;
    }

    function initOne(root) {
      if (!root || root.dataset.vmInitialized === 'true') return;
      root.dataset.vmInitialized = 'true';

      const grid = root.querySelector('[data-vm-qty-atc]');
      if (!grid) return;

      const qtyControl = grid.querySelector('[data-vm-qty-control]');
      const qtyInput = grid.querySelector('[data-vm-qty-input]');
      const qtyDisplay = grid.querySelector('[data-vm-qty-display]');
      const btnInc = grid.querySelector('[data-vm-inc]');
      const btnDec = grid.querySelector('[data-vm-dec]');
      const btnATC = grid.querySelector('[data-vm-atc]');
      const btnBuy = grid.querySelector('[data-vm-buy]');
      const errEl = root.querySelector('[data-vm-error]');
      const variantIdInput = root.querySelector('[data-vm-variant-id]');

      if (!qtyControl || !qtyInput || !qtyDisplay || !btnInc || !btnDec || !btnATC || !btnBuy || !variantIdInput) return;

      const productId = root.getAttribute('data-vm-product-id') || 'x';
      const sectionId = root.getAttribute('data-vm-section-id') || 'x';
      const storageKey = `vm_qty_${productId}_${sectionId}`;

      const min = toInt(qtyControl.dataset.min, 1);
      const step = toInt(qtyControl.dataset.step, 1);
      const max = qtyControl.dataset.max ? toInt(qtyControl.dataset.max, 999999) : null;

      function showError(msg) {
        if (!errEl) return;

        if (!msg) {
          errEl.hidden = true;
          errEl.textContent = '';
          return;
        }

        errEl.hidden = false;
        errEl.textContent = msg;
      }

      function getProductSection() {
        return root.closest('[id^="ProductSection-"]') || document;
      }

      function getVariantPicker() {
        return getProductSection().querySelector('variant-picker');
      }

      function cleanOptionName(name) {
        const text = String(name || '').trim().toLowerCase();

        if (text.includes('size')) return 'size';
        if (text.includes('color') || text.includes('colour')) return 'color';

        return text || 'variant option';
      }

      function optionLooksLikeSize(optionWrap) {
        const name = cleanOptionName(optionWrap.dataset.vmOptionName || '');
        const values = String(optionWrap.dataset.vmOptionValues || '').toLowerCase();

        return (
          name.includes('size') ||
          values.includes('30a') ||
          values.includes('32a') ||
          values.includes('34a') ||
          values.includes('36a') ||
          values.includes('38a') ||
          values.includes('40a') ||
          values.includes('s,m,l,xl') ||
          values.includes('s,') ||
          values.includes('xl')
        );
      }

      function markManualVariantSelections() {
        const picker = getVariantPicker();
        if (!picker || picker.dataset.vmManualSelectionReady === 'true') return;

        picker.dataset.vmManualSelectionReady = 'true';

        picker.querySelectorAll('.variant-option[data-vm-option-name]').forEach((optionWrap) => {
          optionWrap.dataset.vmUserSelected = 'false';

          optionWrap.querySelectorAll('input[type="radio"], select').forEach((input) => {
            const markSelected = () => {
              optionWrap.dataset.vmUserSelected = 'true';
              showError('');
            };

            input.addEventListener('change', markSelected);
            input.addEventListener('click', markSelected);
          });
        });

        picker.querySelectorAll('[data-vm-bra-size]').forEach((btn) => {
          btn.addEventListener('click', () => {
            picker.dataset.vmBraSizeSelected = 'true';

            picker.querySelectorAll('.variant-option[data-vm-option-name]').forEach((optionWrap) => {
              if (optionLooksLikeSize(optionWrap)) {
                optionWrap.dataset.vmUserSelected = 'true';
              }
            });

            showError('');
          });
        });
      }

      function customBraSizeSelected() {
        const picker = getVariantPicker();
        if (!picker) return false;

        const activeBtn = picker.querySelector('[data-vm-bra-size].is-active');
        return !!activeBtn || picker.dataset.vmBraSizeSelected === 'true';
      }

      function getMissingVariantOptions() {
        const picker = getVariantPicker();
        if (!picker) return [];

        markManualVariantSelections();

        const missing = [];

        picker.querySelectorAll('.variant-option[data-vm-option-name]').forEach((optionWrap) => {
          const optionName = cleanOptionName(optionWrap.dataset.vmOptionName || '');
          const isSizeOption = optionLooksLikeSize(optionWrap);

          const hasManualSelection = optionWrap.dataset.vmUserSelected === 'true';

          const checkedRadio = optionWrap.querySelector('input[type="radio"]:checked');
          const select = optionWrap.querySelector('select');

          const hasActualSelection =
            !!checkedRadio ||
            !!(select && select.value && select.value.trim() !== '');

          // if (isSizeOption) {
          //   if (customBraSizeSelected() || hasManualSelection) {
          //     return;
          //   }

          //   missing.push('size');
          //   return;
          // }

          if (isSizeOption) {
          if (customBraSizeSelected() || hasManualSelection || hasActualSelection) {
            return;
          }

          missing.push('size');
          return;
        }

          if (!hasManualSelection && !hasActualSelection) {
            missing.push(optionName);
          }
        });

        return [...new Set(missing)];
      }

      function validateVariantSelection() {
        const missing = getMissingVariantOptions();

        if (!missing.length) {
          showError('');
          return true;
        }

        const message =
          missing.length === 1
            ? 'Please select the ' + missing[0] + '.'
            : 'Please select the ' + missing.join(' and ') + '.';

        showError(message);
        return false;
      }

      markManualVariantSelections();

      function clamp(v) {
        let val = toInt(v, min);
        if (val < min) val = min;
        if (max !== null && val > max) val = max;
        return val;
      }

      function setQty(v) {
        const next = clamp(v);
        qtyInput.value = String(next);
        qtyDisplay.textContent = String(next);

        btnDec.disabled = next <= min;
        btnInc.disabled = max !== null ? next >= max : false;

        try {
          sessionStorage.setItem(storageKey, String(next));
        } catch (e) {}
      }

      function getQty() {
        return clamp(qtyInput.value);
      }

      try {
        const saved = sessionStorage.getItem(storageKey);
        if (saved) setQty(saved);
        else setQty(qtyInput.value || min);
      } catch (e) {
        setQty(qtyInput.value || min);
      }

      btnInc.addEventListener('click', function (e) {
        stopAll(e);
        setQty(getQty() + step);
      }, true);

      btnDec.addEventListener('click', function (e) {
        stopAll(e);
        const current = getQty();
        if (current <= min) return;
        setQty(current - step);
      }, true);

      let cachedCartCount = null;
      fetchCartJSON()
        .then((cart) => { cachedCartCount = cart.item_count; })
        .catch(() => {});

      async function handleATC(e) {
        stopAll(e);
        if (btnATC.disabled) return;

        showError('');

        if (!validateVariantSelection()) return;

        btnATC.classList.add('is-loading');
        btnATC.setAttribute('aria-busy', 'true');

        const variantId = toInt(variantIdInput.value, 0);
        const quantity = getQty();

        try {
          if (!variantId) throw new Error('Variant not selected.');

          // Open the cart sidebar instantly after a valid click, then show drawer loader
          // until /cart/add.js and cart drawer section refresh are completed.
          openVmCartDrawer();
          showVmCartDrawerLoader();

          const visible = getVisibleCartCount();
          const base = visible !== null ? visible : cachedCartCount !== null ? cachedCartCount : 0;
          setCartCountEverywhere(base + quantity);

          const addData = await addToCart(variantId, quantity);

          const cart = await fetchCartJSON();
          cachedCartCount = cart.item_count;
          setCartCountEverywhere(cart.item_count);
          dispatchVmCartAddEvents(cart, addData);
        } catch (err) {
          try {
            const cart = await fetchCartJSON();
            cachedCartCount = cart.item_count;
            setCartCountEverywhere(cart.item_count);
          } catch (_) {}

          showError(err?.message || 'Something went wrong.');
          hideVmCartDrawerLoader(true);
        } finally {
          btnATC.classList.remove('is-loading');
          btnATC.removeAttribute('aria-busy');
        }
      }

      async function handleBuyNow(e) {
        stopAll(e);
        if (btnBuy.disabled) return;

        showError('');

        if (!validateVariantSelection()) return;

        btnBuy.classList.add('is-loading');
        btnBuy.setAttribute('aria-busy', 'true');

        const variantId = toInt(variantIdInput.value, 0);
        const quantity = getQty();

        try {
          if (!variantId) throw new Error('Variant not selected.');

          const visible = getVisibleCartCount();
          const base = visible !== null ? visible : cachedCartCount !== null ? cachedCartCount : 0;
          setCartCountEverywhere(base + quantity);

          await addToCart(variantId, quantity);

          const cart = await fetchCartJSON();
          cachedCartCount = cart.item_count;
          setCartCountEverywhere(cart.item_count);

          window.location.assign('/checkout');
        } catch (err) {
          try {
            const cart = await fetchCartJSON();
            cachedCartCount = cart.item_count;
            setCartCountEverywhere(cart.item_count);
          } catch (_) {}

          showError(err?.message || 'Something went wrong.');
          btnBuy.classList.remove('is-loading');
          btnBuy.removeAttribute('aria-busy');
        }
      }

      const productSection = getProductSection();
      const productVariantId = root.getAttribute('data-vm-product-id');

      const handleVariantUpdate = (event) => {
        if (!event.detail?.resource?.id) return;
        if (event.detail.data?.productId && productVariantId && event.detail.data.productId !== productVariantId) return;

        variantIdInput.value = event.detail.resource.id;

        const isAvailable = event.detail.resource.available !== false;
        if (isAvailable) {
          btnATC.removeAttribute('disabled');
          btnBuy.removeAttribute('disabled');
        } else {
          btnATC.setAttribute('disabled', 'disabled');
          btnBuy.setAttribute('disabled', 'disabled');
        }
      };

      const handleVariantSelected = () => {
        btnATC.setAttribute('disabled', 'disabled');
        btnBuy.setAttribute('disabled', 'disabled');
      };

      if (productSection) {
        productSection.addEventListener('variant:update', handleVariantUpdate);
        productSection.addEventListener('variant:selected', handleVariantSelected);
      }

      btnATC.addEventListener('click', handleATC, true);
      btnBuy.addEventListener('click', handleBuyNow, true);
    }

    function initAll() {
      installVmCartDrawerLoaderWatchers();
      ensureVmCartDrawerLoader();
      document.querySelectorAll('.vm-qty-atc').forEach(initOne);
    }

    initAll();
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:section:reorder', initAll);
    document.addEventListener('shopify:block:select', initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
